import styles from "./ImageSlider.module.css";
import { useEffect, useState } from "react";
import arrow from "../../assets/arrow.png";
import tempImage from "../../assets/tempIMG1.jpg";

export default function ImageSlider({
  images = [tempImage],
  filter = false,
  isRotating = false,
}) {
  const [currentIndex, setCurretIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(0);

  // IMAGE ACTIONS
  useEffect(() => {
    if (images.length > 0 && images[0] === images[1]) {
      // images = images.shift();
    }
  }, [images]);

  const prevImage = () => {
    if (currentIndex > 0) {
      setNextIndex((prevVal) => prevVal - 1);
      setTimeout(() => {
        setCurretIndex((prevVal) => prevVal - 1);
      }, [300]);
    } else {
      setNextIndex(images.length - 1);
      setTimeout(() => {
        setCurretIndex(images.length - 1);
      }, [300]);
    }
  };

  const nextImage = () => {
    if (currentIndex < images.length - 1) {
      setNextIndex((prevVal) => prevVal + 1);
      setTimeout(() => {
        setCurretIndex((prevVal) => prevVal + 1);
      }, [300]);
    } else {
      setNextIndex(0);
      setTimeout(() => {
        setCurretIndex(0);
      }, [300]);
    }
  };

  const showSpecificImage = (e) => {
    const value = parseInt(e.target.getAttribute("value"));
    setNextIndex(value);
    setTimeout(() => {
      setCurretIndex(value);
    }, [300]);
  };

  /* AUTOMATIC IMAGE TRANSITION */

  useEffect(() => {
    if (isRotating) {
      const timeout = setTimeout(() => {
        nextImage();
      }, [3000]);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [currentIndex]);

  return (
    <main className={styles.main}>
      <div className={styles[`image-container`]}>
        <img
          src={images[currentIndex]}
          alt="Image."
          className={`${styles[filter && `image-filter`]} ${styles.image}`}
        />
        {currentIndex !== nextIndex && (
          <img
            src={images[nextIndex]}
            alt="Image."
            className={`${styles[filter && `image-filter`]} ${styles.image} ${
              styles[`image-transition`]
            }`}
          />
        )}
      </div>
      <div className={styles.actions}>
        <div
          className={styles[`left-arrow-container`]}
          onClick={nextIndex === currentIndex ? prevImage : () => {}}
        >
          <img
            src={arrow}
            alt="Arrow."
            className={`${styles[`left-arrow`]} ${styles[`arrow`]}`}
          />
        </div>
        <div className={styles.dots}>
          {images.map((img, i) => (
            <div
              className={`${styles.dot} ${
                styles[nextIndex === i && `dot-active`]
              }`}
              key={i}
              value={i}
              onClick={
                nextIndex === currentIndex ? showSpecificImage : () => {}
              }
            />
          ))}
        </div>
        <div
          className={styles[`right-arrow-container`]}
          onClick={nextIndex === currentIndex ? nextImage : () => {}}
        >
          <img src={arrow} alt="Arrow." className={styles[`arrow`]} />
        </div>
      </div>
    </main>
  );
}
